import * as actions from 'actions/firebase'
import { ActionType, getType } from 'typesafe-actions'
import { QuestionStatistics } from 'types/QuestionStatistics'
import { FirebaseError } from 'firebase'
type FirebaseActions = ActionType<typeof actions>
interface FirebaseState {
  statistics?: QuestionStatistics
  firebaseError?: FirebaseError
  isLoggedIn: boolean
}

export const firebaseReducer = (
  state: FirebaseState = { isLoggedIn: false },
  action: FirebaseActions
) => {
  switch (action.type) {
    case getType(actions.setStatistics):
      return {
        ...state,
        statistics: action.payload
      }

    case getType(actions.authError):
    case getType(actions.dbError):
      return {
        ...state,
        firebaseError: action.payload
      }

    case getType(actions.logIn):
      return {
        ...state,
        isLoggedIn: true
      }

    case getType(actions.logOut):
      return {
        ...state,
        isLoggedIn: false
      }
  }

  return state
}
